export const formatoMXN = (centavos: number, idioma: "es" | "en" = "es") =>
  new Intl.NumberFormat(idioma === "es" ? "es-MX" : "en-US", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: centavos % 100 === 0 ? 0 : 2,
  }).format(centavos / 100);

export type Desglose = { adultos: number; ninos: number; adultoCentavos: number; ninoCentavos: number };

export const calcularTotal = ({ adultos, ninos, adultoCentavos, ninoCentavos }: Desglose) => {
  if (!Number.isInteger(adultos) || !Number.isInteger(ninos) || adultos < 0 || ninos < 0) throw new Error("Cantidades inválidas");
  return adultos * adultoCentavos + ninos * ninoCentavos;
};
